<script setup lang="ts">
import findXs from "~/assets/icons/find/find-xs.svg"

const { conversationsByUpdatedAt, matchingConversations } = useConversations()
const { onCreateOrOpenLatestConversationIntent } = useAgent()
const { panelChatsId } = useGlobals()
const searchResults: Ref<StaticConversation[]> = ref([])
const isSearching = ref(false)
const searchInput = useTemplateRef("searchInput")

async function onNewChatClick() {
  return onCreateOrOpenLatestConversationIntent()
}

async function onSearchQueryUpdated() {
  if (!searchInput.value)
    throw new Error("Search input is not defined")
  const query = searchInput.value.value.trim()
  if (!query) {
    isSearching.value = false
    searchResults.value = []
    return
  }
  isSearching.value = true
  searchResults.value = await matchingConversations(query)
}
</script>

<template>
  <div :id="panelChatsId" class="chats">
    <div class="chats-search-and-add">
      <div class="search">
        <find-xs class="search-icon" />
        <input
          ref="searchInput"
          class="input-inner"
          type="text"
          placeholder="Search past chats..."
          @input="onSearchQueryUpdated()"
        >
      </div>
      <div class="add" @click="onNewChatClick()">
        <icon-action
          type="plus"
          size="xs"
        />
        New Chat
      </div>
    </div>
    <menu-separator />
    <interface-scrollbar
      vertical
    >
      <div class="chats-view">
        <panel-chats-item
          v-for="conversation of (isSearching ? searchResults : conversationsByUpdatedAt)"
          :key="conversation.id"
          :conversation
        />
      </div>
    </interface-scrollbar>
  </div>
</template>

<style lang="sass" scoped>
@import '~/assets/styles/generated/variables.sass'

.chats
  @apply flex flex-col
  @apply h-full

.chats-search-and-add
  @apply p-4
  @apply t-menu-sm
  @apply flex items-center flex-none
  .add
    @apply ml-auto
    @apply cursor-pointer
    @apply flex items-center justify-center flex-none
    @apply p-0.5 pr-1.5 -my-0.5 rounded-[6px]
    &:hover
      @apply bg-[#{$menu-bg-item-hover}]

.search
  @apply flex items-center gap-1 min-w-0
  .search-icon
    @apply text-[#{$global-bg-icon-secondary-alt}]
  input
    @apply bg-transparent
    @apply t-menu-sm
    @apply ring-none focus:ring-0 outline-none
    &::placeholder
      @apply text-[#FFFFFF50]

.chats-view
  @apply h-full flex flex-col gap-3
  @apply p-4
</style>
